import { developmentConfig } from './develop';
import { testConfig } from './test';
import { productionConfig } from './production';
import { demoConfig } from './demo';
import { dynamicConfig } from './dynamic';
import { stagingConfig } from './staging';

export const eTriageConfig = { developmentConfig, testConfig, productionConfig, demoConfig, dynamicConfig, stagingConfig };
